module.exports = __webpack_public_path__ + "static/media/Apple Macbook Pro 15\" Space Grey.36cd8af9.png";